"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerRelationsChannel = void 0;
const topic_1 = require("../../topic");
const CUSTOMER_RELATIONS_CHANNEL = 'customerRelations';
class CustomerRelationsChannel {
    constructor(_logger) {
        this._logger = _logger;
        this.channel = CUSTOMER_RELATIONS_CHANNEL;
        this.topics = {
            chatActivity: new topic_1.Topic('chatActivity', CUSTOMER_RELATIONS_CHANNEL, this._logger),
            CTA_CustomerRelations_Open: new topic_1.Topic('CTA_CustomerRelations_Open', CUSTOMER_RELATIONS_CHANNEL, this._logger),
        };
    }
}
exports.CustomerRelationsChannel = CustomerRelationsChannel;
//# sourceMappingURL=customer-relations.channel.js.map